function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import profilePic from '../../../../assets/images/profile_pic_5.png';

var Template_5 = function Template_5(props) {
    var defaulValues = {};
    var values = props.values,
        validWebsiteURL = props.validWebsiteURL,
        validImageURL = props.validImageURL,
        validEmail = props.validEmail,
        fetchingTweets = props.fetchingTweets;


    var hasValues = Object.values(values).some(function (val, index) {
        return val && val.length > 0 || typeof val === 'boolean';
    });

    var fontSizeName = values.fontSizeName ? values.fontSizeName + 'px' : '11px';
    var fontStyleName = values.fontStyleName ? values.fontStyleName : '';
    var fontWeightName = values.fontWeightName ? values.fontWeightName : '';
    var fontLineHeightName = values.fontLineHeightName ? values.fontLineHeightName + 'px' : '22px';
    var nameColor = values.selectedColorName ? values.selectedColorName : '#000';

    var fontSizeTitle = values.fontSizeTitle ? values.fontSizeTitle + 'px' : '11px';
    var fontStyleTitle = values.fontStyleTitle ? values.fontStyleTitle : '';
    var fontWeightTitle = values.fontWeightTitle ? values.fontWeightTitle : '';
    var fontLineHeightTitle = values.fontLineHeightTitle ? values.fontLineHeightTitle + 'px' : '22px';
    var titleColor = values.selectedColorTitle ? values.selectedColorTitle : '#000';

    var fontSizeAddress = values.fontSizeAddress ? values.fontSizeAddress + 'px' : '11px';
    var addressColor = values.selectedColorAddress ? values.selectedColorAddress : '#000';
    var addressTextOpacity = values.addressTextOpacity ? values.addressTextOpacity : 1;

    var dividerColor = values.selectedColorDivider ? values.selectedColorDivider : '#000';

    var fontFamily = values.activeFontFamily ? values.activeFontFamily : '';
    var fontSize = values.fontSize ? values.fontSize + 'px' : '11px';
    var templateColor = values.selectedTemplateColor ? values.selectedTemplateColor : '#000';
    var textColor = values.selectedColor ? values.selectedColor : '#000';

    var fixLink = values.website ? values.website : '';
    if (fixLink && !fixLink.startsWith("http://") && !fixLink.startsWith("https://")) {
        fixLink = "https://" + fixLink;
    } else if (fixLink && fixLink.startsWith("http://")) {
        // Do nothing, since the link already starts with "http://"
    }

    if (!hasValues) {
        defaulValues = {
            name: 'Roy Gordon',
            title: 'Marketing Assistant',
            address: 'ex: 649 E Girard Ave Englewood, CO 80113',
            picture: profilePic,
            mobile: '001 123 456 789',
            telephone: '002 222 222 222',
            fax: '003 333 333 333',
            website: 'www.cortab.com',
            email: 'email@cortab.com',
            linkedin: '#',
            skype: '#',
            facebook: '#',
            whatsapp: '#',
            twitterLink: '#',
            instagramLink: '#'
        };
    }

    var whatsappCode = values.phoneCode ? values.phoneCode.substring(1) : defaulValues.phoneCode;

    return React.createElement(
        'div',
        null,
        React.createElement(
            'table',
            { border: '0', cellPadding: '0', cellSpacing: '0', style: { "maxWidth": "400px", "borderBottom": '1px solid ' + dividerColor, paddingBottom: '10px' } },
            React.createElement(
                'tbody',
                null,
                React.createElement(
                    'tr',
                    null,
                    React.createElement(
                        'td',
                        { style: { "maxWidth": "255px", "width": "255px", "verticalAlign": "top" } },
                        values && (values.picture_base64 || values.picture_link || defaulValues.picture) && React.createElement(
                            'div',
                            { style: { verticalAlign: 'top', textAlign: 'center' } },
                            (values.picture_base64 || defaulValues.picture) && !values.picture_link ? React.createElement('img', { style: { verticalAlign: 'middle', width: values.size ? values.size + 'px' : '60px', height: values.size ? values.size + 'px' : '60px', borderRadius: '50%' },
                                src: defaulValues.picture ? defaulValues.picture : values.picture_base64 }) : (values.picture_base64 || defaulValues.picture) && values.picture_link && validImageURL !== true ? React.createElement('img', { style: { verticalAlign: 'middle', width: values.size ? values.size + 'px' : '60px', height: values.size ? values.size + 'px' : '60px', borderRadius: '50%' }, src: defaulValues.picture ? defaulValues.picture : values.picture_base64 }) : validImageURL !== true && values.picture_link && React.createElement('img', { style: { verticalAlign: 'middle', width: values.size ? values.size + 'px' : '60px', height: values.size ? values.size + 'px' : '60px', borderRadius: '50%' }, src: values.picture_link })
                        )
                    ),
                    React.createElement(
                        'td',
                        { style: { "maxWidth": "255px", "width": "255px", "verticalAlign": "middle", paddingLeft: '10px' } },
                        React.createElement(
                            'div',
                            { style: { marginBottom: '10px' } },
                            React.createElement(
                                'div',
                                { style: { "textAlign": "left" } },
                                React.createElement(
                                    'span',
                                    { style: { fontFamily: fontFamily, fontSize: fontSizeName, color: nameColor, fontStyle: fontStyleName, fontWeight: fontWeightName, lineHeight: fontLineHeightName } },
                                    values && values.name ? values.name : defaulValues.name
                                )
                            ),
                            React.createElement(
                                'div',
                                { style: { "marginBottom": "5px", "textAlign": "left" } },
                                React.createElement(
                                    'span',
                                    { style: { fontFamily: fontFamily, fontSize: fontSizeTitle, color: titleColor, fontStyle: fontStyleTitle, fontWeight: fontWeightTitle, lineHeight: fontLineHeightTitle } },
                                    values && values.title ? values.title : defaulValues.title
                                )
                            ),
                            React.createElement(
                                'div',
                                { style: { "marginBottom": "5px", "textAlign": "left", "fontWeight": "normal" } },
                                React.createElement(
                                    'span',
                                    { style: { fontFamily: fontFamily, fontSize: fontSizeAddress, color: addressColor, opacity: addressTextOpacity } },
                                    values && values.address ? values.address : defaulValues.address
                                )
                            )
                        ),
                        values && (values.mobile || defaulValues.mobile) && React.createElement(
                            'div',
                            { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                            React.createElement(
                                'span',
                                { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                                'Mobile:'
                            ),
                            React.createElement(
                                'span',
                                { style: { "marginLeft": "5px" } },
                                React.createElement(
                                    'span',
                                    null,
                                    React.createElement(
                                        'a',
                                        { href: 'tel:' + (values.mobile || defaulValues.mobile) },
                                        React.createElement(
                                            'span',
                                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                                            values.mobile || defaulValues.mobile
                                        )
                                    )
                                )
                            )
                        ),
                        values && (values.telephone || defaulValues.telephone) && React.createElement(
                            'div',
                            { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                            React.createElement(
                                'span',
                                { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                                'Phone:'
                            ),
                            React.createElement(
                                'span',
                                { style: { "marginLeft": "5px" } },
                                React.createElement(
                                    'span',
                                    null,
                                    React.createElement(
                                        'a',
                                        { href: 'tel:' + (values.telephone || defaulValues.telephone) },
                                        React.createElement(
                                            'span',
                                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                                            values.telephone || defaulValues.telephone
                                        )
                                    )
                                )
                            )
                        ),
                        values && (values.fax || defaulValues.fax) && React.createElement(
                            'div',
                            { style: { "whiteSpace": "nowrap", "textAlign": "left", "fontSize": "14px" } },
                            React.createElement(
                                'span',
                                { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                                'Fax:'
                            ),
                            React.createElement(
                                'span',
                                { style: { "marginLeft": "5px" } },
                                React.createElement(
                                    'span',
                                    null,
                                    React.createElement(
                                        'a',
                                        { href: 'tel:' + (values.fax || defaulValues.fax) },
                                        React.createElement(
                                            'span',
                                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                                            values.fax || defaulValues.fax
                                        )
                                    )
                                )
                            )
                        ),
                        validWebsiteURL !== true && values && (values.website || defaulValues.website) && React.createElement(
                            'div',
                            { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                            React.createElement(
                                'span',
                                { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                                'Site:'
                            ),
                            React.createElement(
                                'span',
                                { style: { "marginLeft": "5px" } },
                                React.createElement(
                                    'span',
                                    null,
                                    React.createElement(
                                        'a',
                                        { href: fixLink || defaulValues.website, target: '_blank' },
                                        React.createElement(
                                            'span',
                                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                                            values.website || defaulValues.website
                                        )
                                    )
                                )
                            )
                        ),
                        validEmail !== true && values && (values.email || defaulValues.email) && React.createElement(
                            'div',
                            { style: { "whiteSpace": "nowrap", "textAlign": "left" } },
                            React.createElement(
                                'span',
                                { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, fontWeight: 'bold' } },
                                'Email:'
                            ),
                            React.createElement(
                                'span',
                                { style: { "marginLeft": "5px" } },
                                React.createElement(
                                    'span',
                                    null,
                                    React.createElement(
                                        'a',
                                        { style: { fontFamily: fontFamily, fontSize: fontSize }, href: "mailto:" + (values.email || defaulValues.email) },
                                        React.createElement(
                                            'span',
                                            { style: { fontFamily: fontFamily, fontSize: fontSize, color: textColor } },
                                            values.email || defaulValues.email
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { style: { marginTop: '10px' } },
                            (values.tiktok || values.instagramLink || values.whatsapp && values.phoneCode.length > 1 || values.twitterLink || values.linkedin || values.facebook) && React.createElement(
                                'div',
                                { style: { fontFamily: fontFamily, fontSize: fontSize, color: templateColor, marginTop: '5px', fontWeight: 'bold', marginBottom: '5px' } },
                                'Follow me:'
                            ),
                            (values.linkedin || defaulValues.linkedin) && React.createElement(
                                'a',
                                { href: 'https://www.linkedin.com/in/' + (values.linkedin ? values.linkedin : defaulValues.linkedin), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/linkedin.png' })
                            ),
                            (values.facebook || defaulValues.facebook) && React.createElement(
                                'a',
                                { href: 'https://www.facebook.com/' + (values.facebook ? values.facebook : defaulValues.facebook), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/facebook.png' })
                            ),
                            (values.twitterLink || defaulValues.twitterLink) && React.createElement(
                                'a',
                                { href: 'https://twitter.com/' + (values.twitterLink ? values.twitterLink : defaulValues.twitterLink), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/twitter.png' })
                            ),
                            (values.skype || defaulValues.skype) && React.createElement(
                                'a',
                                { href: 'skype:' + (values.skype ? values.skype : defaulValues.skype), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/skype.png' })
                            ),
                            (values.whatsapp || defaulValues.whatsapp) && (values.phoneCode && values.phoneCode.length > 1 || defaulValues.phoneCode) && React.createElement(
                                'a',
                                { href: 'https://api.whatsapp.com/send?phone=' + (values.phoneCode ? whatsappCode : defaulValues.phoneCode) + (values.whatsapp ? values.whatsapp : defaulValues.whatsapp), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/whatsapp.png' })
                            ),
                            (values.tiktok || defaulValues.tiktok) && React.createElement(
                                'a',
                                { href: 'https://www.tiktok.com/@' + (values.tiktok ? values.tiktok : defaulValues.tiktok), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/tiktok.png' })
                            ),
                            (values.instagramLink || defaulValues.instagramLink) && React.createElement(
                                'a',
                                { href: 'https://www.instagram.com/' + (values.instagramLink ? values.instagramLink : defaulValues.instagramLink), target: '_blank' },
                                React.createElement('img', { style: { marginRight: "3px", width: "20px" }, src: 'https://bluemail.me/img/signature-editor/instagram.png' })
                            )
                        )
                    )
                ),
                values.twitterData && values.twitter && React.createElement(
                    'tr',
                    null,
                    React.createElement(
                        'td',
                        { colSpan: '3' },
                        React.createElement('hr', { style: { "marginTop": "10px", "marginBottom": "10px", "width": "100%", "borderTop": "1px solid #E5E5E5" } })
                    )
                ),
                fetchingTweets === true ? React.createElement(
                    'div',
                    { className: 'sk-cube-grid', style: { margin: '0 auto' } },
                    React.createElement('div', { className: 'sk-cube sk-cube1' }),
                    React.createElement('div', { className: 'sk-cube sk-cube2' }),
                    React.createElement('div', { className: 'sk-cube sk-cube3' }),
                    React.createElement('div', { className: 'sk-cube sk-cube4' }),
                    React.createElement('div', { className: 'sk-cube sk-cube5' }),
                    React.createElement('div', { className: 'sk-cube sk-cube6' }),
                    React.createElement('div', { className: 'sk-cube sk-cube7' }),
                    React.createElement('div', { className: 'sk-cube sk-cube8' }),
                    React.createElement('div', { className: 'sk-cube sk-cube9' })
                ) : values.twitterData && values.twitter && React.createElement(
                    'tr',
                    null,
                    React.createElement(
                        'td',
                        { colSpan: '5' },
                        React.createElement(
                            'div',
                            { id: 'twitter' },
                            React.createElement(
                                'table',
                                { border: '0', width: '100%' },
                                React.createElement(
                                    'tr',
                                    null,
                                    React.createElement(
                                        'td',
                                        { width: '60', style: { "verticalAlign": "top" } },
                                        React.createElement('img', { id: 'twitter-profile-image', src: values.twitterData.user.profile_image_url, style: { "maxWidth": "60px", "borderRadius": "50%" } })
                                    ),
                                    React.createElement(
                                        'td',
                                        null,
                                        React.createElement(
                                            'table',
                                            { border: '0', style: { "width": "100%" } },
                                            React.createElement(
                                                'tr',
                                                null,
                                                React.createElement(
                                                    'td',
                                                    null,
                                                    React.createElement(
                                                        'a',
                                                        { id: 'twitter-screen-name-link', target: '_blank', style: { "textDecoration": "none", "float": "right", "boxSizing": "border-box", "padding": "1px 8px 1px 6px", "backgroundColor": "#1b95e0", "color": "#fff", "borderRadius": "3px", "fontWeight": "500", "cursor": "pointer" }, title: 'Follow',
                                                            href: "https://twitter.com/" + values.twitterData.user.screen_name },
                                                        React.createElement('i', { style: { "position": "relative", "top": "5px", "display": "inline-block", "width": "14px", "height": "14px", "background": "transparent 0 0 no-repeat", "marginRight": "5px", "marginLeft": "2px", "backgroundImage": "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS45MzMiIGhlaWdodD0iOS43MDMiIHZpZXdCb3g9IjAgMCAxMS45MzMgOS43MDMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNNzguODQ5LDEwOC4xYTYuOTIyLDYuOTIyLDAsMCwwLDYuOTY3LTYuOTY3YzAtLjEwNSwwLS4yMSwwLS4zMTVhNC45ODgsNC45ODgsMCwwLDAsMS4yMjItMS4yNyw0Ljk2Miw0Ljk2MiwwLDAsMS0xLjQwOS4zODdBMi40NjQsMi40NjQsMCwwLDAsODYuNyw5OC41ODFhNC44NzEsNC44NzEsMCwwLDEtMS41NTcuNTkyLDIuNDQ5LDIuNDQ5LDAsMCwwLTQuMjM2LDEuNjc2LDIuNzA2LDIuNzA2LDAsMCwwLC4wNjIuNTU5LDYuOTUzLDYuOTUzLDAsMCwxLTUuMDQ3LTIuNTU5LDIuNDU4LDIuNDU4LDAsMCwwLC43NTksMy4yNzEsMi40NzcsMi40NzcsMCwwLDEtMS4xMDgtLjMwNnYuMDMzYTIuNDU0LDIuNDU0LDAsMCwwLDEuOTYzLDIuNCwyLjQ2MywyLjQ2MywwLDAsMS0xLjEuMDQzLDIuNDQ5LDIuNDQ5LDAsMCwwLDIuMjg3LDEuNyw0LjkxMSw0LjkxMSwwLDAsMS0zLjA0MiwxLjA1MSw0LjcxMSw0LjcxMSwwLDAsMS0uNTgzLS4wMzMsNi45NjUsNi45NjUsMCwwLDAsMy43NDksMS4wOTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03NS4xIC05OC40KSIvPjwvc3ZnPg==)" } }),
                                                        React.createElement(
                                                            'span',
                                                            { style: { "color": "#fff", "fontSize": "12px", "cursor": "pointer" } },
                                                            'Follow'
                                                        )
                                                    ),
                                                    React.createElement(
                                                        'span',
                                                        { id: 'twitter-username', style: { "fontSize": "14px", "fontWeight": "bold", "color": "rgba(0,0,0,1)" } },
                                                        values.twitterData.user.name
                                                    ),
                                                    React.createElement(
                                                        'span',
                                                        { id: 'twitter-screen-name', style: { "marginLeft": "5px", "fontSize": "12px", "fontWeight": "bold", "color": "grey" } },
                                                        values.twitterData.user.screen_name
                                                    )
                                                )
                                            ),
                                            React.createElement(
                                                'tr',
                                                null,
                                                React.createElement(
                                                    'td',
                                                    null,
                                                    React.createElement(
                                                        'span',
                                                        { id: 'twitter-date', style: { "float": "left", "fontSize": "12px", "color": "grey" } },
                                                        new Date(Date.parse(values.twitterData.created_at)).toUTCString()
                                                    )
                                                )
                                            ),
                                            React.createElement(
                                                'tr',
                                                null,
                                                React.createElement(
                                                    'td',
                                                    null,
                                                    React.createElement(
                                                        'span',
                                                        { id: 'twitter-text', style: { "textAlign": "left", "fontSize": "12px", "color": "rgba(0,0,0,1)" } },
                                                        values.twitterData.text
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        ),
        values.checkSignature && React.createElement(
            'div',
            { style: { display: 'block', margin: '10px auto 0 auto', textAlign: 'center' } },
            React.createElement(
                'a',
                { className: 'getBlueMail', style: _defineProperty({ display: 'block', textAlign: 'center', margin: '10px auto 0 auto', color: '#1F6BF1', textDecoration: 'underline', fontSize: '14px' }, 'textAlign', 'center'), href: 'https://bluemail.me/download', target: '_blank' },
                'Get BlueMail'
            )
        )
    );
};

export default Template_5;


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/Templates/5.js